import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { I18nProvider, SUPPORTED_LANGS, DEFAULT_LANG, getStaticDict } from "@/i18n/I18nProvider";
import ScrollToTop from "@/components/site/ScrollToTop";
import SiteLayout from "@/components/site/SiteLayout";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import ThankYouPage from "@/pages/ThankYouPage";

function LangRoot() {
  const { lang } = useParams();
  const location = useLocation();
  const activeLang = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;

  useEffect(() => {
    const dict = getStaticDict(activeLang);
    document.title = dict.meta.title;
    document.documentElement.lang = activeLang === "pe" ? "es-PE" : "en";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", dict.meta.description);
  }, [activeLang, location.pathname]);

  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }

  return (
    <I18nProvider lang={activeLang}>
      <SiteLayout />
    </I18nProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route path="/thank_you" element={<ThankYouPage />} />
        <Route path="/:lang" element={<LangRoot />}>
          <Route index element={<HomePage />} />
          <Route
            path="privacy"
            element={<LegalPage i18nKey="privacy" testIdPrefix="privacy" />}
          />
          <Route
            path="cookies"
            element={<LegalPage i18nKey="cookie_policy" testIdPrefix="cookies" />}
          />
          <Route
            path="terms"
            element={<LegalPage i18nKey="terms" testIdPrefix="terms" />}
          />
          <Route path="*" element={<Navigate to="." replace />} />
        </Route>
        <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
